import React, {Component} from 'react';
import {Button} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import {publicUrl} from '../Api';

export default class Landing extends Component {
    render() {
        return (
            <div className="landing">
                <Helmet>
                    <link href={`${publicUrl}/css/full-height.css`} rel="stylesheet"/>
                </Helmet>
                <div className="content">
                    <h1>{'Deep Contrast'}</h1>
                    <p><em>{'Improve your image'}</em></p>
                    <Link to="/demo"><Button bsStyle="primary" style={{width: 200}}>{'GALLERY'}</Button></Link>
                    <Link to="/images/my"><Button bsStyle="success" style={{width: 200}}>{'ENTER'}</Button></Link>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Landing.js